var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_24684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C12.6522 20.5 15.1957 19.4464 17.0711 17.5711C18.9464 15.6957 20 13.1522 20 10.5C20 7.84784 18.9464 5.3043 17.0711 3.42893C15.1957 1.55357 12.6522 0.5 10 0.5C7.34784 0.5 4.8043 1.55357 2.92893 3.42893C1.05357 5.3043 0 7.84784 0 10.5C0 13.1522 1.05357 15.6957 2.92893 17.5711C4.8043 19.4464 7.34784 20.5 10 20.5ZM14.4141 8.66406L9.41406 13.6641C9.04688 14.0312 8.45312 14.0312 8.08984 13.6641L5.58984 11.1641C5.22266 10.7969 5.22266 10.2031 5.58984 9.83984C5.95703 9.47656 6.55078 9.47266 6.91406 9.83984L8.75 11.6758L13.0859 7.33594C13.4531 6.96875 14.0469 6.96875 14.4102 7.33594C14.7734 7.70312 14.7773 8.29687 14.4102 8.66016L14.4141 8.66406Z",
    fill: "#4ADE80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_24684"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H20V20.5H0V0.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightmark);
export default __webpack_public_path__ + "static/media/rightmark.2f46dac467b8946ea806221e1bd8dbf8.svg";
export { ForwardRef as ReactComponent };